import './DoctorTable.scss';

import { notification } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { Button, Label } from 'semantic-ui-react';

import * as api from '../../../stores/api';
import customFetch from '../../../utils/customFetch';
import Tooltip from '../../shared/Tooltip';
import accreditations from './accreditations';
import DoctorInfoPopover from './DoctorInfoPopover';
import RequestDoctorInfoModal from './RequestDoctorInfoModal';
import Table from './Table';
import { stringifyDoctorConsultingLocations } from './utils';
import dashboardStore from '@stores/dashboard';
import _ from 'lodash';

const avatarPlaceholder =
  'data:image/jpeg;base64,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';
const doctorTableName = 'DOCTOR_TABLE';

class DoctorName extends React.Component {
  onMouseEnter = event => {
    this.props.onMouseEnter(event, {
      id: this.props.id,
      title: this.props.drTitle,
      firstName: this.props.firstName,
      lastName: this.props.lastName,
    });
  };

  handleOpenTabDoctorDetail = event => {
    event.preventDefault();
    const { id, firstName, lastName } = this.props;
    localStorage.setItem('DoctorName', `${firstName} ${lastName}`);
    dashboardStore.close('/view/add-edit-doctor-2', true);
    setTimeout(() => {
      dashboardStore.open(`/view/add-edit-doctor-2?id=${id}&action=view`);
    });
  };

  render() {
    return (
      <div className="link" onMouseEnter={this.onMouseEnter} onMouseLeave={this.props.onMouseLeave}>
        <div className="text-center">
          <img
            alt="avatar"
            className="profile-picture--small"
            src={
              this.props.profilePicturePath
                ? `/UserFile/DoctorAttachment/${this.props.profilePicturePath}`
                : avatarPlaceholder
            }
          />
        </div>
        <div className="text-center">
          {api.isAdminOrMagStaffOrAccounting() ? (
            <Link to="#" className="link" onClick={this.handleOpenTabDoctorDetail}>
              {this.props.drTitle} {this.props.firstName} {this.props.lastName}{' '}
              {`${this.props.registerOption ? `(${this.props.registerOption})` : ''}`}
            </Link>
          ) : (
            `${this.props.drTitle} ${this.props.firstName} ${this.props.lastName}`
          )}
        </div>
      </div>
    );
  }
}

@observer
class DoctorTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doctor: null,
      showDoctorInfoPopover: false,
      isLoadingDoctorInfo: false,
      doctorInfoTitle: null,
      doctorInfoName: null,
      doctorInfoBriefProfile: null,
      doctorInfoCommissionOnTop: null,
      doctorInfoConsultingLocations: null,
      doctorInfoServiceExclusion: null,
      doctorInfoPopoverBottom: 0,
      doctorInfoPopoverLeft: 0,
      isRequestDoctorInfoModalOpen: false,
      requestDoctorInfoModalDoctorId: 0,
    };
    this.fieldList = [
      {
        id: 'FirstName',
        text: 'Specialist',
        tableName: doctorTableName,
        sortable: true,
        renderRer: d => {
          return (
            <DoctorName
              id={d.Id}
              firstName={d.FirstName}
              lastName={d.LastName}
              drTitle={d.Title}
              profilePicturePath={d.ProfilePicturePath}
              onMouseEnter={this.onMouseEnterDoctorName}
              onMouseLeave={this.onMouseLeaveDoctorName}
              registerOption={d?.RegisterOption || null}
            />
          );
        },
      },

      {
        id: 'Specialties',
        text: 'Specialty',
        tableName: doctorTableName,
        sortable: true,
        renderRer: ({ Specialties }) => (
          <React.Fragment>
            {!!Specialties &&
              Specialties.split(',').map(tag => (
                <Label className="label-tag" key={tag}>
                  {tag}
                </Label>
              ))}
            {/* {!api.isCaseManager() && RegisterOption && <Label className="label-tag">{(RegisterOption)}</Label>} */}
          </React.Fragment>
        ),
      },
      {
        id: 'Sub-specialties',
        text: 'Sub-Specialty',
        tableName: doctorTableName,
        sortable: true,
        renderRer: ({ SubSpecialties }) =>
          !!SubSpecialties &&
          SubSpecialties.split(',').map(tag => (
            <Label className="label-tag" key={tag}>
              {tag}
            </Label>
          )),
      },
      {
        id: 'Accreditations',
        text: 'Accreditations',
        tableName: doctorTableName,
        sortable: true,
        renderRer: d => {
          return (d.Accreditations || '')
            .split(/,\s*/g)
            .sort()
            .map((a, i) => (
              <React.Fragment key={a}>
                {!!i && ', '}
                <Tooltip appear={accreditations.descriptions ? accreditations.descriptions[a] || a : null}>
                  <span className="link">{a}</span>
                </Tooltip>
              </React.Fragment>
            ));
        },
      },
      {
        id: 'TeleAssessment',
        text: 'Video Asessment',
        tableName: doctorTableName,
        sortable: true,
        renderRer: d => {
          return (
            <React.Fragment>
              <div>{d.TeleAssessment === 0 ? 'Unsure' : d.TeleAssessment === 1 ? 'Yes' : 'No'}</div>
            </React.Fragment>
          );
        },
      },
      {
        id: 'Clinic',
        text: 'Clinic',
        tableName: doctorTableName,
        sortable: true,
        renderRer: d => (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', height: '100%' }}>
            {d.NoAppointment
              ? d.dataGroupById?.map((item, index) => this.renderClinic(item, index))
              : this.renderClinic(d)}
          </div>
        ),
      },
      {
        id: 'RequestFor',
        text: '',
        tableName: doctorTableName,
        sortable: true,
        renderRer: d => (
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-around', height: '100%' }}>
            {d.NoAppointment
              ? d.dataGroupById?.map((item, index) => this.renderRequestFor(item, index))
              : this.renderRequestFor(d)}
          </div>
        ),
      },
    ];
  }

  renderRequestFor = (d, index = 0) => {
    const { Id, Sessions } = d;
    const nosession = !Sessions || !Sessions.length;
    return (
      <div className="d-flex flex-column columnBtns">
        {(api.isCaseManager() || api.isAdminOrMagStaffOrAccounting()) && (
          <>
            {api.isCaseManager() && !d.DoctorCV && (
              <Button
                className="requestMoreDoctorInfoBtn"
                content={'Request CV'}
                onClick={() => {
                  this.setState({
                    doctor: d,
                    isRequestDoctorInfoModalOpen: true,
                    requestDoctorInfoModalDoctorId: Id,
                  });
                }}
              />
            )}
            {d.DoctorCV && (
              <Button
                className="requestMoreDoctorInfoBtn"
                content={'View CV'}
                onClick={() => {
                  this.setState({
                    doctor: d,
                    isRequestDoctorInfoModalOpen: true,
                    requestDoctorInfoModalDoctorId: Id,
                  });
                }}
              />
            )}
            {api.isCaseManager() && !d.SampleReport && (
              <Button
                className="requestMoreDoctorInfoBtn"
                style={{ marginTop: '4px' }}
                content={'Request Sample Reports'}
                onClick={() => {
                  this.setState({
                    doctor: d,
                    isRequestDoctorInfoModalOpen: true,
                    requestDoctorInfoModalDoctorId: Id,
                  });
                }}
              />
            )}
            {d.SampleReport && (
              <Button
                className="requestMoreDoctorInfoBtn"
                style={{ marginTop: '4px' }}
                content={'View Sample Reports'}
                onClick={() => {
                  this.setState({
                    doctor: d,
                    isRequestDoctorInfoModalOpen: true,
                    requestDoctorInfoModalDoctorId: Id,
                  });
                }}
              />
            )}
          </>
        )}
        <Button
          className="requestAnotherAppointmentBtn"
          content={`Request an${nosession ? '' : 'other'} appointment`}
          onClick={this.closureHandleRequestClick(Id)}
        />
      </div>
    );
  };

  renderClinic = (d, index = 0) => {
    return (
      <React.Fragment>
        {index !== 0 ? <br /> : ''}

        <div className="dr-name-distance">
          <div>{d.ClinicName}</div> <div className="distance">({d.DistanceText})</div>
        </div>

        {d.ClinicAddress && (
          <a
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            href={`https://www.google.com/maps?q=${d.ClinicAddress.replace(/[^\d\w]+/g, '+')}`}
          >
            {d.ClinicAddress}
          </a>
        )}
      </React.Fragment>
    );
  };

  onMouseEnterDoctorName = (event, doctor) => {
    const popoverMinHeight = 300;
    const popoverMaxWidth = 600;
    const { innerHeight, innerWidth } = window;

    const element = event.currentTarget;
    const { top, right, bottom, left } = element.getBoundingClientRect();

    const position = {};
    let classNames = '';
    if (top > popoverMinHeight) {
      position.bottom = innerHeight - top;
      classNames = 'top';
    } else {
      position.top = bottom;
      classNames = 'bottom';
    }

    if (left + popoverMaxWidth > innerWidth) {
      position.right = innerWidth - right - 17;
      classNames += ' right';
    } else {
      position.left = left;
      classNames += ' left';
    }

    this.setState({
      showDoctorInfoPopover: true,
      isLoadingDoctorInfo: true,
      position,
      popoverClassNames: classNames,
      doctorInfoTitle: doctor.title,
      doctorInfoName: doctor.firstName + ' ' + doctor.lastName,
    });

    customFetch(`/api/doctorInfo/${doctor.id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }).then(data => {
      this.setState({
        isLoadingDoctorInfo: false,
        doctorInfoBriefProfile: data.profileAndPreferences,
        doctorInfoCommissionOnTop: data.commissionOnTop,
        doctorInfoConsultingLocations: stringifyDoctorConsultingLocations(data.consultingLocations),
        doctorInfoServiceExclusion: data.serviceExclusion,
        doctorBookingsAndCancellationTerms: data.doctorBookingsAndCancellationTerms,
      });
    });
  };
  onMouseLeaveDoctorName = event => {
    this.setState({
      showDoctorInfoPopover: false,
    });
  };

  closureHandleRequestClick = dId => () => {
    localStorage.setItem('AssessmentCaseId', 'Book Assessment');
    dashboardStore.close('/view/add-edit-ime-assessment-2');
    setTimeout(() => {
      dashboardStore.open(`/view/add-edit-ime-assessment-2?dId=${dId}`);
    });
  };

  renderAccordion = d => {
    //
    if (d.ImmediateAvailable) {
      return (
        <div className="DoctorTable__monthlySession immediateAvailable">
          <span>
            <strong>Sessions By Month (Available/Total Slots):</strong>
          </span>
        </div>
      );
    }
    //
    const { Doctors = [], TotalSession, NoAppointment, MonthText, AvailableSession } = d;
    let uniqueDoctorCount = 0;
    const uniqueDoctorMap = {};
    Doctors.forEach(d => {
      if (!uniqueDoctorMap[d.Id]) {
        uniqueDoctorMap[d.Id] = true;
        uniqueDoctorCount += 1;
      }
    });
    //
    if (NoAppointment) {
      return (
        <div className="DoctorTable__monthlySession available">
          <span>
            <strong>Specialists Available by Request: {uniqueDoctorCount}</strong>
          </span>
        </div>
      );
    }
    //
    return (
      <div className="DoctorTable__monthlySession">
        <span className="DoctorTable__monthlySession__month">
          <strong>{MonthText}</strong>
        </span>
        <span className="DoctorTable__monthlySession__doctor">
          Specialists: <strong>{uniqueDoctorCount}</strong>
        </span>
        <span>
          {api.isCaseManager() ? 'Available Sessions: ' : 'Sessions: '}
          <strong>
            {AvailableSession}
            {!api.isCaseManager() && `/ ${TotalSession}`}
          </strong>
        </span>
      </div>
    );
  };

  requestDoctorInfoModalHandleOk = ({ doctorId, isRequestDoctorCvChecked, isRequestDoctorSampleReportChecked }) => {
    this.setState({ isRequestDoctorInfoModalOpen: false });
    customFetch('/search/RequestMoreDoctorInfo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        doctorId,
        isRequestDoctorCvChecked,
        isRequestDoctorSampleReportChecked,
      }),
    }).then(data => {
      requestAnimationFrame(() => {
        notification.info({
          message: 'Success',
          description: 'Your request has been received. We will be in contact with you shortly.',
          key: 'requestDoctorInfoModalSaved',
        });
      });
    });
  };

  requestDoctorInfoModalHandleClose = () => {
    this.setState({ isRequestDoctorInfoModalOpen: false });
  };

  render() {
    const l = this.props.smartSearchResult;
    const listWithId = (l || [])
      .map(i => {
        if (i.NoAppointment) {
          const doctorsGroupBy = _.chain(i.Doctors).groupBy('Id');
          const doctors = doctorsGroupBy
            .map((value, key) => {
              const dataGroupById = value.map(item => ({
                ClinicName: item.ClinicName,
                DistanceText: item.DistanceText,
                ClinicAddress: item.ClinicAddress,
                Sessions: item.Sessions,
                Id: item.Id,
                DoctorCV: item.DoctorCV,
                SampleReport: item.SampleReport,
              }));
              return {
                ...value[0],
                dataGroupById,
                ImmediateAvailable: i.ImmediateAvailable,
                NoAppointment: i.NoAppointment,
              };
            })
            .value();

          return {
            ...i,
            Doctors: doctors,
            Id: i.ImmediateAvailable ? 'ImmediateAvailable' : i.NoAppointment ? 'NoAppointment' : i.MonthText,
          };
        }

        return {
          ...i,
          Doctors: (i.Doctors || []).map(d => ({
            ...d,
            uniqueId: `${d.Id}-${d.ClinicId}`,
          })),
          Id: i.ImmediateAvailable ? 'ImmediateAvailable' : i.NoAppointment ? 'NoAppointment' : i.MonthText,
        };
      })
      .sort(a => {
        if (a.NoAppointment) return -1;
        else return 0;
      });

    return (
      <div className="table-scroll">
        <Table
          fieldList={this.fieldList}
          list={listWithId}
          hasList={!!l}
          accordion={true}
          keyList="Doctors"
          accordionRenderer={this.renderAccordion}
          onMouseEnter={this.onMouseEnterDoctorName}
          onMouseLeave={this.onMouseLeaveDoctorName}
          timeZone={this.props.timeZone}
          reportTypes={this.props.reportTypes}
        />

        {this.state.showDoctorInfoPopover &&
          ReactDOM.createPortal(
            <DoctorInfoPopover
              isLoading={this.state.isLoadingDoctorInfo}
              position={this.state.position}
              classNames={this.state.popoverClassNames}
              doctorTitle={this.state.doctorInfoTitle}
              doctorName={this.state.doctorInfoName}
              doctorBriefProfile={this.state.doctorInfoBriefProfile}
              doctorCommissionOnTop={this.state.doctorInfoCommissionOnTop}
              doctorConsultingLocations={this.state.doctorInfoConsultingLocations}
              doctorServiceExclusion={this.state.doctorInfoServiceExclusion}
              doctorBookingsAndCancellationTerms={this.state.doctorBookingsAndCancellationTerms}
            />,
            document.body,
          )}

        {this.state.isRequestDoctorInfoModalOpen && (
          <RequestDoctorInfoModal
            doctor={this.state.doctor}
            doctorId={this.state.requestDoctorInfoModalDoctorId}
            isOpen={this.state.isRequestDoctorInfoModalOpen}
            handleOk={this.requestDoctorInfoModalHandleOk}
            handleClose={this.requestDoctorInfoModalHandleClose}
          />
        )}
      </div>
    );
  }
}

export default DoctorTable;
